import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {isMobile} from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';
import {showAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import ServiceButtons from 'app/Components/Shared/ServiceButtons/ServiceButtons';
import {replacePlaceholders} from '../../../../utilities/StringHelpers/TitleHelpers';

const GeneralMessage = ({
  messageData,
  buttonClick,
  secondButtonClick,
  linkAction,
  secondLinkAction,
  data,
  userDetails,
  showAppLoader,
  marketCode,
}) => {
  const {
    icon,
    title,
    secondTitle,
    contactUs,
    buttonText,
    secondButtonText,
    linkText,
    secondLinkText,
    borderedMessage = false,
    report,
  } = messageData;
  const tel =window.Config.technicalSupportPhone;
  const whatsApp =
    marketCode == 'GLN'
      ? 'https://api.whatsapp.com/send/?phone=0587778888&text&type=phone_number&app_absent=0'
      : 'https://cellcom.co.il/clm/16/20/';
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhReportOnLoad();
    }
  }, []);

  function dwhReportOnLoad() {
    if (report) {
      switch (report) {
        case 'futureAbroadError':
          dwhGeneralReport({
            data: {...data, userDetails: userDetails},
            actionType: DwhActionType.SelectLineAddressPage,
            messageText: DWHMessageText.ErrorAbroadPackageDisplayed,
            status: DWHStatus.Error,
          });
          break;
        case 'generalError':
          dwhGeneralReport({
            data: {...data, userDetails: userDetails},
            actionType: DwhActionType.SelectLineAddressPage,
            messageText: DWHMessageText.GeneralError,
            status: DWHStatus.Error,
          });
          break;
        case 'paymentUpdateError':
        case 'debtError':
        case 'debtAndPaymentUpdateError':
          dwhGeneralReport({
            data: {...data, userDetails: userDetails},
            actionType: DwhActionType.SelectLineAddressPage,
            messageText: DWHMessageText.ErrorDebtDisplayed,
            status: DWHStatus.Error,
          });
          break;
        case 'successPage':
          dwhGeneralReport({
            data: {...data, userDetails: userDetails},
            actionType: DwhActionType.SuccessScreen,
            messageText: DWHMessageText.SuccessScreen,
            status: DWHStatus.Completed,
          });
          break;
        case 'mustVisitServiceCenter':
          dwhGeneralReport({
            data: {...data, userDetails: userDetails},
            actionType: DwhActionType.NewOwnerDetailPage,
            messageText: DWHMessageText.BlacklistError,
            status: DWHStatus.Completed,
          });
          break;
        // case 'technicianVisitError': //row 430
        //     dwhGeneralReport({
        //         data: { ...data, userDetails: userDetails },
        //         actionType: DwhActionType.ErrorScreen,
        //         messageText: DWHMessageText.,
        //         status: DWHStatus.Ongoing,
        //     });
        //     break;

        default:
          break;
      }
    }
  }

  const handleSubmit = (buttonAction) => {
    showAppLoader();
    if (buttonAction) {
      buttonAction();
    }
  };

  return (
    <div className='ownership-transfer-step messagePage'>
      <Image src={icon} />
      <p className='l-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(title, data, isMobile)}} />
      {secondTitle && <p className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(secondTitle, data, isMobile)}} />}
      {contactUs && (
        <div className='contact-us'>
          <ServiceButtons hideLobbyUrl={true} hideTitle={true} tel={tel} whatsappUrl={whatsApp} />
        </div>
      )}

      {linkText && (
        <div className='link-wrapper'>
          <a className='link' href='' onClick={() => handleSubmit(linkAction)}>
            {linkText}
          </a>
        </div>
      )}
      {secondLinkText && (
        <div className='link-wrapper'>
          <a className='link' href='' onClick={() => handleSubmit(secondLinkAction)}>
            {secondLinkText}
          </a>
        </div>
      )}

      {borderedMessage && (
        <div className='bordered-text'>
          <div className='m-sub-title'>
            הקישור שישלח לבעלים העתידי יהיה בתוקף
            <br />
            <span className='semi'>למשך 24 שעות מרגע שליחת ההודעה.</span>
          </div>
        </div>
      )}

      <div className='continue-button'>
        {buttonText && <BtnSubmit text={buttonText} onclick={() => handleSubmit(buttonClick)} />}
        {secondButtonText && (
          <BtnWhiteBlackBorderBigSize className={`second-button`} text={secondButtonText} onclick={() => handleSubmit(secondButtonClick)} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.authentication?.loginData?.userDetails,
  data: state.OwnershipTransferPrivateSeller,
  marketCode: state.domain.MarketCode,
});

const mapDispatchToProps = {showAppLoader};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessage);
